<template>
    <div class="td-autocomplete form-item">
        <div v-if="!hideLabel">
            <label for="listing">Select Listing: </label>
        </div>
        <div :class="[!selectedListing && searchTermListing ? 'focused': '', 'autocomplete-input']">
            <div v-if="selectedListing" class="td-selected-input">
                <span>
                    {{selectedListing.display}}
                    <a href="#" class="input-deselect" @click.prevent="selectListing()">
                        <icon type="solid" name="faXmark" aria-hidden="true"></icon>
                    </a>
                </span>
            </div>
            <input v-if="!selectedListing" type="text"
                   placeholder="Select listing from the list"
                   name="listing"
                   id="listing"
                   @focus="showListingList = true"
                   v-model="searchTermListing"
                    :class="{ error: isError}"
                   @keyup.enter="selectListing(listingList[0])" />
        </div>
        <div></div>
        <div :class="[!selectedListing && showListingList ? 'show-results' : 'hide-results', 'autocomplete-results']">
            <ul class="results-list" v-if="listingList.length > 0">
                <li v-for="(item, idx) in listingList" :key="idx">
                    <a @click.prevent="selectListing(item)" href="#">{{item.display}}</a>
                </li>
            </ul>
            <ul class="results-list" v-else>
                <li class="td-text-subdued pa-1">
                    No listings found
                </li>
            </ul>
        </div>

    </div>
</template>
<script>import script from './ListingLookup';
    export default script;</script>
